
import React from 'react'
import { Card as RCard } from 'react-bootstrap'

import './Card.scss'

interface IButton {
  icon: JSX.Element
  label: string
  shortLabel?: string
  className?: string
  onClick: () => void
  visible?: boolean
  active?: boolean
}

interface Props {
  title?: string | JSX.Element
  children: any
  className?: string
  buttons?: IButton[]
}

const Card = (props: Props) => {

  const { title, children, className, buttons } = props

  return (
    <RCard className={`card pl4nner-card ${className}`}>
      <RCard.Body>
        <div className="body-header">
          {title && (
            <h4 className='card-title'>
              {title}
            </h4>
          )}
          {buttons && (
            <div className="body-header-buttons-group">
              {buttons.map((button: IButton, i: number) => (
                <button
                  key={i}
                  className={`btn btn-link btn-body-header ${button.className} ${button.active && 'active'}`}
                  onClick={button.onClick}
                >
                  {button.icon}
                  {button.shortLabel && <span className="d-inline d-md-none"> {button.shortLabel}</span>}
                  <span className="d-none d-md-inline"> {button.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </RCard.Body>
      {children}
    </RCard>
  )
}

export default Card
